<mat-tab-group>
    <mat-tab label="Programs">
        <mat-card-title id="header">
            Program Maintenance
        </mat-card-title>
        <table mat-table [dataSource]="programs" class="program-table mat-elevation-z8">
            <ng-container matColumnDef="edit">
                <th mat-header-cell *matHeaderCellDef id="edit-column"></th>
                <td mat-cell *matCellDef="let program" (click)="openEditProgramDialog(program)">
                    <mat-icon color="primary" fontIcon="edit"></mat-icon>
                </td>
            </ng-container>

            <ng-container matColumnDef="shortName">
                <th mat-header-cell *matHeaderCellDef id="short-name-column"> Short Name </th>
                <td mat-cell *matCellDef="let program">
                    <div *ngIf="program.shortName != null">
                        {{ program.shortName }}
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="longName">
                <th mat-header-cell *matHeaderCellDef> Long Name </th>
                <td mat-cell *matCellDef="let program">
                    {{ program.longName }}
                </td>
            </ng-container>

            <ng-container matColumnDef="description">
                <th mat-header-cell *matHeaderCellDef> Description </th>
                <td mat-cell *matCellDef="let program">
                    {{ program.description }}
                </td>
            </ng-container>

            <ng-container matColumnDef="available">
                <th mat-header-cell *matHeaderCellDef> Available </th>
                <td mat-cell *matCellDef="let program" id="available-column">
                    <div *ngIf="program.available; else noTemplate">
                        Yes
                    </div>
                    <ng-template #noTemplate>
                        No
                    </ng-template>
                </td>
            </ng-container>

            <ng-container matColumnDef="startDate">
                <th mat-header-cell *matHeaderCellDef> Start Date </th>
                <td mat-cell *matCellDef="let program" id="start-date-column">
                    {{ program.startDate | date:'longDate' }}
                </td>
            </ng-container>

            <ng-container matColumnDef="endDate">
                <th mat-header-cell *matHeaderCellDef> End Date </th>
                <td mat-cell *matCellDef="let program" id="end-date-column">
                    {{ program.endDate | date:'longDate' }}
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr 
                mat-row
                (click)="selectProgramName(row.name)"
                [class.is-row-clicked]="selectedProgramName === row.name"
                *matRowDef="let row; columns: displayedColumns;"
            ></tr>
        </table>
    </mat-tab>

    <mat-tab label="Program Details">
        <div *ngIf="isProgramNameSelected; else noProgramSelected">
            <one-ring-program-detail-component
                [programDetails]="programDetails"
                (detailUpdateComplete)="handleDetailUpdate()"
            ></one-ring-program-detail-component>
        </div>
        <ng-template #noProgramSelected>
            <p id="select-notification">
                You must select a program before viewing its details
            </p>
        </ng-template>
    </mat-tab>
</mat-tab-group>
